import React from 'react';
import { useLocale } from '../../localization/LocaleContext';

export default function FAQ5(){
    const { t } = useLocale();
    return(
        <div className="question mt-40">
            <h4 className="h-4 h-bold">
                {t('faq.contactUs.heading')}
            </h4>
            <p className="paragraph p-adjustment text-left">
                {t('faq.contactUs.text')}
                <span>
                    <a style={{marginLeft:"5px"}} href={"mailto:{support@invoicepoint.app}"}>
                        support@invoicepoint.app
                    </a>
                </span>
                !
            </p>
        </div>
    )
}